// extracted by mini-css-extract-plugin
export const images_slider = "ImageViewer-module--images_slider--I5a8S";
export const original_image_container = "ImageViewer-module--original_image_container--2vyOP";
export const translated_image_container = "ImageViewer-module--translated_image_container--29GGa";
export const original_image = "ImageViewer-module--original_image--28F4f";
export const translated_image = "ImageViewer-module--translated_image--2AdqF";
export const range_container = "ImageViewer-module--range_container--1vU20";
export const range = "ImageViewer-module--range--3ZSMN";